export type PrintModeloAnaliseQualidade = "rotas-totais" | "rotas-produtores" | "produtores";

export type PrintOptionsAnaliseQualidade = {
	modelo: PrintModeloAnaliseQualidade;
	incluirResumo: boolean;
};

export const PRINT_OPTIONS_STORAGE_KEY = "lacto:analise-qualidade:print-options";

export function defaultPrintOptions(activeTab: string): PrintOptionsAnaliseQualidade {
	if (activeTab === "rotas") {
		return { modelo: "rotas-produtores", incluirResumo: true };
	}

	return { modelo: "produtores", incluirResumo: true };
}

export function loadPrintOptions(): PrintOptionsAnaliseQualidade | null {
	try {
		const raw = window.localStorage.getItem(PRINT_OPTIONS_STORAGE_KEY);
		if (!raw) {
			return null;
		}

		const parsed = JSON.parse(raw) as PrintOptionsAnaliseQualidade;
		if (!parsed?.modelo) {
			return null;
		}

		return {
			modelo: parsed.modelo,
			incluirResumo: parsed.incluirResumo !== false,
		};
	} catch {
		return null;
	}
}

export function savePrintOptions(options: PrintOptionsAnaliseQualidade): void {
	window.localStorage.setItem(PRINT_OPTIONS_STORAGE_KEY, JSON.stringify(options));
}
